import React, { useEffect } from "react";
import { Switch, useLocation } from "react-router-dom";
import { HAS_MULTITENANT } from "@common/config";
import ProtectedRoute from "./PrivateRoute";
import Home from "@modules/home/pages/home";
import Dimensions from "./RouteDimensions";
import Editor from "./RouteEditor";
import EditorGroupsManager from "./RoutesEditorGroupsManager";
import Booking from "./RouteBooking";
import ReportsRoutes from "./ReportsRoutes";
import ReportsList from "@modules/reports/pages/reports-list";
import Catalogs from "@modules/home/pages/catalogs";
import { resetAdvancedSearchStore, useAdvancedSearchStore } from "@context/useAdvancedSearchStore";
import { setToken as setIdentityToken } from "@services/collections/identity/keycloakServices";
import ProgrammingStructures from "@modules/programming-structures/pages/programming-structures";
import ProgrammingStructuresCreation from "@modules/programming-structures/pages/programming-structures-creation";
import I18nCatalog from "@modules/i18n-catalog/pages/i18n-catalog";

const moduleRoutes = [
  {
    path: "/programming-structures/list/:workspace/:scenario/:origin",
    component: ProgrammingStructures,
  },
  {
    path: "/programming-structures/new/:workspace/:scenario/:origin",
    component: ProgrammingStructuresCreation,
  },
  {
    path: "/programming-structures/update/:workspace/:scenario/:origin/:id",
    component: ProgrammingStructuresCreation,
  },
  {
    path: "/programming-structures/details/:workspace/:scenario/:origin/:id",
    component: ProgrammingStructuresCreation,
  },
  {
    path: "/report/:subpage?",
    component: ReportsRoutes,
  },
  {
    path: "/editor/groups-manager/:subpage?",
    component: EditorGroupsManager,
  },
  {
    path: "/editor/:subpage?",
    component: Editor,
  },
  {
    path: "/catalogs/:workspace/:scenario/:origin",
    component: Catalogs,
  },
  {
    path: "/reports/:workspace/:scenario",
    component: ReportsList,
  },
  {
    path: "/reports/:workspace/:scenario/:origin",
    component: ReportsList,
  },
  {
    path: "/catalogs/:workspace/:scenario",
    component: Catalogs,
  },
  {
    path: "/scheduler/:subpage?",
    component: Dimensions,
  },
  {
    path: "/booking/:subpage?",
    component: Booking,
  },
  {
    path: "/home/:workspace/:scenario/:origin",
    component: Home,
  },
  {
    path: "/home/:workspace/:scenario",
    component: Home,
  },
  // Internal tool, deliberately absent from the sidebar: reached by direct URL.
  // Has to stay above the "/" catch-all, which matches everything below it.
  {
    path: "/internal/translations",
    component: I18nCatalog,
  },
  {
    path: "/",
    component: Home,
  },
];

const Shell = () => {
  const location = useLocation();
  const hasAdvancedSearchState = useAdvancedSearchStore(state => state.hasState);

  useEffect(() => {
    if (HAS_MULTITENANT) {
      const params = new URLSearchParams(location.search);
      const accessToken = params.get("access_token");
      if (accessToken) {
        setIdentityToken(accessToken);
        params.delete("access_token");
        const newSearch = params.toString();
        const newUrl =
          window.location.pathname + (newSearch ? `?${newSearch}` : "") + window.location.hash;
        window.history.replaceState({}, document.title, newUrl);
      }
    }
  }, []);

  useEffect(() => {
    const isAdvancedSearchPath = ["/editor/advanceSearch", "/editor/searchBy"].some(path =>
      location.pathname.includes(path),
    );

    if (hasAdvancedSearchState && !isAdvancedSearchPath) {
      resetAdvancedSearchStore();
    }
  }, [location?.pathname]);

  return (
    <Switch>
      {moduleRoutes.map(route => (
        <ProtectedRoute key={route.path} path={route.path} component={route.component} />
      ))}
    </Switch>
  );
};

export default Shell;
